import { Component, Input, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { ProcessService } from 'src/app/modules/instance/services/process.service';
import { GeneralProcessType } from 'src/app/modules/scheduler/enums/general-process-type';
import ITask = ZoningAPI.ITask;

@Component({
    standalone: false,
    selector: 'app-stop-all-processes-button',
    templateUrl: './stop-all-processes-button.component.html',
    styleUrls: ['./stop-all-processes-button.component.scss']
})
export class StopAllProcessesButtonComponent implements OnInit {
    @Input()
    stopJobs: boolean;

    @Input()
    stopTasks: boolean;

    buttonLabel: string;

    constructor(private readonly processService: ProcessService) {}

    ngOnInit(): void {
        this.buttonLabel = 'Stop All ' + (this.stopJobs ? 'Jobs' : this.stopTasks ? 'Tasks' : ' Processes');
    }

    stopAllProcesses(): void {
        const processType = this.stopJobs ? GeneralProcessType.JOB : this.stopTasks ? GeneralProcessType.TASK : null;
        this.processService.stopAllProcesses(processType).subscribe((updatedProcessesData: ITask[]) => {
            this.processService.updateProcesses(updatedProcessesData);
        });
    }
}
